/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Empty_State_Hint_CreateInputs */



/**
* | output |
* | --- |
* | "Click the + button to create your first issue" |
*
* @param {Manual_Qc_Empty_State_Hint_CreateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_empty_state_hint_create = /** @type {((inputs?: Manual_Qc_Empty_State_Hint_CreateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Empty_State_Hint_CreateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cliquez sur le bouton + pour creer votre premier incident")
	if (locale === "de") return /** @type {LocalizedString} */ ("Klicken Sie auf die Schaltfläche „+“, um Ihre erste Ausgabe zu erstellen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Clicca sul pulsante + per creare il tuo primo numero")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нажмите кнопку «+», чтобы создать свой первый выпуск.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Haga clic en el botón + para crear su primer número")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("点击“+”按钮创建您的第一个问题")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最初の問題を作成するには+ボタンをクリックしてください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपना पहला अंक बनाने के लिए + बटन पर क्लिक करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Clique no botão + para criar sua primeira edição.")
	return /** @type {LocalizedString} */ ("Click the + button to create your first issue")
});